export default {"src":"/_next/static/media/camera-white.31eda401.svg","height":48,"width":48};